import { useEffect } from "react";

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr.name, attr.value); document.head.appendChild(el); }
  el.setAttribute("content", value);
}

export function usePageTitle(title) {
  useEffect(() => {
    if (!title) return;
    document.title = title;
    setMeta('meta[property="og:title"]', { name: "property", value: "og:title" }, title);
    setMeta('meta[name="twitter:title"]', { name: "name", value: "twitter:title" }, title);
  }, [title]);
}

export function formatDate(d, lang) {
  return new Date(d).toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" });
}
